import { useAuth } from "@/shared/hooks";
import { EventTypes, useEvents } from "@/shared/hooks/useEvents";

export const PackagesToSignEventPrefix = "PACKAGESTOSIGN";

type PackageToSignEvents = {
    packagesToSignStarted: () => void;
    packagesToSignStopped: () => void;
    packagesToSignFinalized: (connectiveStatus: string) => void;
    packagesToSignProgressed: () => void;
};

export const usePackagesToSignEvents = (): PackageToSignEvents => {
    const { user } = useAuth();
    const eventService = useEvents(PackagesToSignEventPrefix);

    const packagesToSignStarted = () => {
        eventService.trackEvent(EventTypes.Start, { withLogin: !user.isScopedLogin() });
    };

    const packagesToSignStopped = () => {
        eventService.trackEvent(EventTypes.Stopped);
    };

    const packagesToSignFinalized = (connectiveStatus) => {
        eventService.trackEvent(EventTypes.Finalized, { connectiveStatus });
    };

    const packagesToSignProgressed = () => {
        eventService.trackEvent(EventTypes.Progressed);
    };

    return {
        packagesToSignStarted,
        packagesToSignStopped,
        packagesToSignFinalized,
        packagesToSignProgressed,
    };
};
